// import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router/index';
import pinia from './store';
import utils from '@/utils/utils';
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(utils);
// app.use(DataV, { classNamePrefix: 'dv-' });

app.mount('#app');
